  <div id="loginContainer" class="container-fluid">
    <div id="loginRow" class="row">
      <div id="loginCol" class="col-xl-4 offset-xl-4 col-lg-6 offset-lg-3 col-md-8 offset-md-2 login-form">
        <a class="central_logo"> <img class="img-fluid" alt="IPOS Central LOGO" /> </a>
        <!-- two-FA Section --> 
        <div id="loginCard" class="card email_sent_card card login_card">
          <form [formGroup]="twoFASentForm" (keyup)="onKeyUp($event)">
            <!-- (ngSubmit)="goBackHome()"> -->
            <div class="form_header_twoFA" [innerHTML]="GlobalConst.TWO_FACTOR_AUTHENTICATION"></div>
            <div class="form-group">
              <input id="verificationCode" type="hidden" [placeholder]="GlobalConst.TWO_FACTOR_AUTHENTICATION_EMAIL_PLACEHOLDER"
                class="form-control" (paste)="onOTPPaste($event)" [ngClass]="{'formfield_err_msg':isOTPExpired,'verificationCode':twoFATextlen}" 
                formControlName="verifyCode" [(ngModel)]="finalValue"/>
                <h6 *ngIf="!(isOTPExpired || isWrongCodeAttempt)">{{GlobalConst.TWO_FACTOR_AUTHENTICATION_EMAIL_PLACEHOLDER}}</h6>
                <span class="unit-digit-wrapper form_header_twoFA">
                  <input [formControlName]='i' id="{{i}}" class="unit-digit" autofocus type="text" placeholder="_" maxlength="1" *ngFor="let i of [1,2,3,4,5,6]"/>
                </span> 
                <em class="err_icon"  *ngIf="false"></em>
                <div class="help-block">
                  <span id="pwdErrMsg" class="formfield_err_msg" *ngIf="(isOTPExpired || isWrongCodeAttempt)?true:false"
                    [innerHTML]="((isOTPExpired) ? GlobalConst.TWO_FACTOR_AUTHENTICATION_CODE_EXPIRED : (isWrongCodeAttempt? ((codeAttemptCount > 0) ? wrongCodeTxt : GlobalConst.MAX_ATTEMPTS):''))">
                  </span>
                </div>
            </div>
            <div class="code-sent" [ngClass]="isCodeSent?'show':'hide'">
              <span class="ml-1" [ngClass]="{'default-cursor':(codeAttemptCount > 0)}">
                <em></em> {{GlobalConst.CODE_SENT_TEXT}} 
              </span>              
            </div>
            <div class="code-validity" [ngClass]="!isCodeSent?'show':'hide'">
              <span class="ml-1" [ngbPopover]="" placement="left"
                triggers="mouseenter:mouseleave" (click)="doActionBasicTimer('reset')">
                <em class="activeImg"></em> {{GlobalConst.RESEND_CODE}}
              </span>
              <!-- For future reference regarding 12 hours account blocking fuctionlity -->
              <!-- <span class="ml-1" [ngClass]="{'default-cursor':(codeAttemptCount > 0 && !isOTPExpired)}" [ngbPopover]="" placement="left"
                triggers="mouseenter:mouseleave" (click)="(codeAttemptCount == 0 || isOTPExpired)?doActionBasicTimer('reset'):''">
                <em [ngClass]="(codeAttemptCount == 0 || isOTPExpired)?'activeImg':'disableImg'"></em> {{GlobalConst.RESEND_CODE}} 
                <strong>({{codeAttemptCount}})</strong>
              </span> -->
              <span class="code-validity-span"[ngClass]="(!isOTPExpired && codeAttemptCount > 0)?'show':'hide'">{{GlobalConst.CODE_VALID}} 
                <strong>
                  <cd-timer #basicTimer format="user" countdown="true" [startTime]="595"
                  (onComplete)="onComplete($event)" (onTick)="onTick($event)"
                  (onStart)="onStart($event)">[minutes] : [seconds] </cd-timer>
                </strong>
              </span>
            </div> 
            <div class="email_sent_btn">
              <button type="submit" class="btn btn-primary verify" [innerHTML]="verifyBtnTxt" 
              (click)="verifyBtn()" [disabled]="(isOTPExpired || (codeAttemptCount ==0) || (twoFATextlen != 6))">
              </button>
            </div>
            <div class="go-back" (click)="goBackHome()"><em></em>&nbsp;<span>{{GlobalConst.GO_BACK}}</span></div>      
          </form>
        </div>
      </div>
    </div>
  </div>
  <!-- <ng-template #popContent>
    <div id="popOver" class="popover-upload-req">
      Code can be requested a maximum <br/> of 10 times. Try again in 12 hours
    </div>
  </ng-template> -->